import { render, staticRenderFns } from "./placement.vue?vue&type=template&id=00aa8e4a&scoped=true"
import script from "./placement.vue?vue&type=script&lang=js"
export * from "./placement.vue?vue&type=script&lang=js"
import style0 from "./placement.vue?vue&type=style&index=0&id=00aa8e4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aa8e4a",
  null
  
)

export default component.exports